module.exports = __webpack_public_path__ + "static/media/carousel_intro-mobile.14e3f3f4.gif";